export default {
  maxHeight: 100, // Threshold where the "read-more" button appears
  title: 'Edición',
  type: 'bibliography/bibl_edition',
  bodyClasses: 'biblio-layout',
  sections: {
    top: [
      {
        id: 'header',
        type: 'title',
        grid: null,
      },
      {
        id: 'editor_metadata',
        type: 'metadata',
        grid: null
      }
    ],
    content: [
      {
        id: 'parent-record',
        type: 'collection',
        grid: 1,
        title: 'resource#parent-record',
      },
      {
        id: 'complete-title',
        type: 'collection',
        grid: 1,
        title: 'resource#complete-title',
      },
      {
        id: 'metadata',
        type: 'metadata',
        title: 'resource#metadata'
      },
      {
        id: 'collection-samples',
        type: 'collection',
        grid: 1,
        title: 'resource#collection-samples',
      },
    ],
  },
};
